import React, { SFC, ReactElement } from 'react';
import styled from 'styled-components';
import { forIE } from '@westwing/ui-kit/breakPoints';

const StyledPageHeadingWrapper = styled.div`
    grid-area: title;
    position: relative;

    ${forIE`
    -ms-grid-row: 1;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
`}
`;

const PageTitle: SFC = ({ children }): ReactElement => <StyledPageHeadingWrapper>{children}</StyledPageHeadingWrapper>;

export default PageTitle;
